import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { setSelectedVenue } from "../actions/venue";
import { VENUES } from "../const/URL.const";



export function useVenueSelection() {
    const dispatch = useDispatch();
    const history = useHistory();

    function selectVenue(venueId?: string) {
       if(venueId){
        localStorage.removeItem('orders');
        localStorage.setItem('selected-venue-id', venueId);
        dispatch(setSelectedVenue(venueId));
        history?.push(VENUES);
       }else{
        localStorage.removeItem('selected-venue-id')
       }
    }
    return selectVenue;
}